import { ReactNode, useRef } from 'react';
import { createPortal } from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import {
  DialogOverlay,
  DialogWrapper,
  DialogContainer,
  DialogBlock,
  DialogHeader,
  DialogContent,
  DialogClose,
  DialogHeaderWrapper,
} from './styles';
import FocusLock from 'react-focus-lock';
import { IoMdClose } from 'react-icons/io';

type DialogType = {
  isOpen: boolean;
  children: ReactNode;
  onClose: () => void;
  header?: ReactNode;
  width?: string;
  autoFocus?: boolean;
};

export const ANIMATION_TIMEOUT = 150;
export const DIALOG_ID = 'modal';
export const DIALOG_WIDTH = '600px';

export const Dialog = ({ isOpen, header, children, width = DIALOG_WIDTH, onClose, autoFocus = true }: DialogType) => {
  const nodeRef = useRef(null);

  return createPortal(
    <CSSTransition
      in={isOpen}
      nodeRef={nodeRef}
      timeout={{ enter: ANIMATION_TIMEOUT, exit: 0 }}
      classNames='fade'
      unmountOnExit
    >
      <FocusLock autoFocus={autoFocus}>
        <DialogWrapper>
          <DialogOverlay />
          <DialogContainer>
            <DialogBlock width={width} ref={nodeRef}>
              <DialogHeaderWrapper>
                <DialogHeader>{header}</DialogHeader>
                <DialogClose onClick={onClose}>
                  <IoMdClose />
                </DialogClose>
              </DialogHeaderWrapper>
              <DialogContent>{children}</DialogContent>
            </DialogBlock>
          </DialogContainer>
        </DialogWrapper>
      </FocusLock>
    </CSSTransition>,
    document.getElementById(DIALOG_ID)
  );
};
